(() => {
  const roots = document.querySelectorAll('[data-sofasizer]');
  if (!roots.length) return;

  roots.forEach((root) => {
    let cards = Array.from(root.querySelectorAll('.sofasizer__card'));
    const tabButtons = root.querySelectorAll('.sofasizer__tab');
    const panels = root.querySelectorAll('.sofasizer__panel');
    const heightInput = root.querySelector('[data-size-input="height"]');
    const widthInput = root.querySelector('[data-size-input="width"]');
    const depthInput = root.querySelector('[data-size-input="depth"]');
    const sizeWrap = root.querySelector('[data-options="size"]');
    const colorWrap = root.querySelector('[data-options="color"]');
    const typeWrap = root.querySelector('[data-options="type"]');
    const priceMinRange = root.querySelector('[data-price-range="min"]');
    const priceMaxRange = root.querySelector('[data-price-range="max"]');
    const priceDisplayMin = root.querySelector('[data-price-display="min"]');
    const priceDisplayMax = root.querySelector('[data-price-display="max"]');
    const priceLimitMin = root.querySelector('[data-price-limit="min"]');
    const priceLimitMax = root.querySelector('[data-price-limit="max"]');
    const priceTrack = root.querySelector('[data-price-track]');
    const priceTooltipMin = root.querySelector('[data-price-tooltip="min"]');
    const priceTooltipMax = root.querySelector('[data-price-tooltip="max"]');
    const filtersWrap = root.querySelector('[data-filters]');
    const clearBtn = root.querySelector('[data-clear-filters]');
    const resultsMeta = root.querySelector('[data-results-meta]');
    const topWidthProduct = root.querySelector('[data-top-width-product]');
    const emptyState = root.querySelector('[data-empty]');
    const heroImage = root.querySelector('[data-sofasizer-image]');
    const heroPlaceholder = root.querySelector('[data-sofasizer-placeholder]');
    const stage = root.querySelector('.sofasizer__stage');
    const stageGrid = root.querySelector('.sofasizer__grid');
    const axisX = root.querySelector('.sofasizer__axis-x');
    const axisY = root.querySelector('.sofasizer__axis-y');
    const sofaWrap = root.querySelector('.sofasizer__sofa');
    const resizeWrap = root.querySelector('.sofasizer__resize');
    const resizeHandle = root.querySelector('[data-resize-handle]');
    const resizeLabel = root.querySelector('.sofasizer__resize-label');
    const maxWidth = parseFloat(root.dataset.maxWidth || widthInput?.max || '450');
    const maxHeight = parseFloat(root.dataset.maxHeight || heightInput?.max || '120');
    const maxDepth = parseFloat(root.dataset.maxDepth || depthInput?.max || '120');
    const resultsWrap = root.querySelector('.sofasizer__results');
    const collectionHandle = root.dataset.collectionHandle || 'all';
    const totalPages = parseInt(root.dataset.totalPages || '1', 10);
    const loadMoreBtn = root.querySelector('[data-load-more]');
    const pageSize = Math.max(1, parseInt(root.dataset.pageSize || '8', 10) || 8);
    let currentLimit = pageSize;
    let hasMoreResults = false;
    let isAutoLoadingMore = false;
    let autoLoadObserver = null;
    let autoLoadScrollRaf = null;
    const currencySymbol = root.dataset.currencySymbol || '£';

    const state = {
      height: null,
      width: null,
      depth: null,
      activeDimension: null,
      sizes: new Set(),
      colors: new Set(),
      typeMaterials: new Set(),
      typeSofaTypes: new Set(),
      typeSeats: new Set(),
      priceMin: null,
      priceMax: null,
    };

    const uniq = (list) => Array.from(new Set(list)).filter(Boolean).sort();
    const cleanMetaToken = (value) =>
      (value || '')
        .toString()
        .replace(/\u00A0/g, ' ')
        .trim()
        .replace(/^[\["']+/, '')
        .replace(/[\]"']+$/, '')
        .replace(/\s+/g, ' ')
        .trim();
    const normalize = (value) => {
      let n = cleanMetaToken(value).toLowerCase().replace(/\bgray\b/g, 'grey').trim();
      if (n.includes('charcoal')) return 'charcoal';
      return n;
    };
    const normalizeSize = (value) =>
      normalize(value)
        .replace(/\s*([x×])\s*/g, '$1')
        .replace(/\s*\+\s*/g, '+')
        .replace(/\s*-\s*/g, '-')
        .replace(/\s+/g, ' ')
        .trim();
    const canonicalSize = (value) =>
      normalizeSize(value)
        .replace(/\b(sofa|settee)\b/g, '')
        .replace(/\bseaters?\b/g, 'seat')
        .replace(/\s+/g, ' ')
        .trim();
    const excludedSizeFilterValues = new Set(
      ['2+1', '2+1+1', '2+2', '3+1', '3+1+1', '3+2', '3+2+1', '3+2+2', '3+3']
        .map((value) => canonicalSize(value))
        .filter(Boolean)
    );
    const extractSizeComboSignature = (value) => {
      const normalized = canonicalSize(value);
      if (!normalized) return '';
      const compact = normalized
        .replace(/[^0-9+]/g, '')
        .replace(/\+{2,}/g, '+')
        .replace(/^\+|\+$/g, '');
      if (!compact.includes('+')) return '';
      const parts = compact.split('+').filter(Boolean);
      if (parts.length < 2) return '';
      return parts.join('+');
    };
    const isExcludedSizeFilterValue = (value) => {
      const normalized = canonicalSize(value);
      if (!normalized) return false;
      if (excludedSizeFilterValues.has(normalized)) return true;

      const comboSignature = extractSizeComboSignature(normalized);
      if (comboSignature) return excludedSizeFilterValues.has(comboSignature);

      return false;
    };
    const sanitizeSelectedSizes = () => {
      if (!state.sizes.size) return;
      Array.from(state.sizes).forEach((value) => {
        if (isExcludedSizeFilterValue(value)) state.sizes.delete(value);
      });
    };
     const toLabel = (value) => {
      if (value === 'charcoal') return 'Charcoal';
      return (value || '')
        .toString()
        .split(' ')
        .filter(Boolean)
        .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
        .join(' ');
    };
    const extractSeatNumber = (value) => {
      const norm = canonicalSize(value);
      if (!norm) return null;
      const seatMatch = norm.match(/(\d+(?:\.\d+)?)\s*-?\s*seat\b/);
      if (seatMatch && seatMatch[1]) return seatMatch[1];
      if (/^\d+(?:\.\d+)?$/.test(norm)) return norm;
      return null;
    };
    const toSeatLabel = (value) => {
      if (!value) return '';
      if (value === 'corner') return 'Corner';
      if (value === 'l shape') return 'L Shape';
      if (value === 'u shape') return 'U Shape';
      const match = value.match(/^(\d+(?:\.\d+)?)\s*seater$/);
      if (!match) return toLabel(value);
      return `${match[1]} Seater`;
    };
    const toSizeLabel = (value) => {
      if (!value) return '';
      const norm = canonicalSize(value);
      if (!norm) return '';
      const seatNumber = extractSeatNumber(norm);
      if (seatNumber !== null) return `${seatNumber} Seater`;
      if (norm === 'l shape') return 'L Shape';
      if (norm === 'u shape') return 'U Shape';
      return toLabel(norm);
    };
    const seatSort = (a, b) => {
      if (a.value === 'corner' && b.value !== 'corner') return 1;
      if (b.value === 'corner' && a.value !== 'corner') return -1;
      const aNum = Number.parseFloat((a.value.match(/^(\d+(?:\.\d+)?)/) || [])[1] || 'NaN');
      const bNum = Number.parseFloat((b.value.match(/^(\d+(?:\.\d+)?)/) || [])[1] || 'NaN');
      if (Number.isFinite(aNum) && Number.isFinite(bNum)) return aNum - bNum;
      if (Number.isFinite(aNum)) return -1;
      if (Number.isFinite(bNum)) return 1;
      return a.label.localeCompare(b.label);
    };
    const sizeOptionSort = (a, b) => {
      const aPriority = Number.isFinite(a.priority) ? a.priority : Number.MAX_SAFE_INTEGER;
      const bPriority = Number.isFinite(b.priority) ? b.priority : Number.MAX_SAFE_INTEGER;
      if (aPriority !== bPriority) return aPriority - bPriority;
      const aNum = Number.parseFloat(extractSeatNumber(a.value) || 'NaN');
      const bNum = Number.parseFloat(extractSeatNumber(b.value) || 'NaN');
      if (Number.isFinite(aNum) && Number.isFinite(bNum)) return aNum - bNum;
      if (Number.isFinite(aNum)) return -1;
      if (Number.isFinite(bNum)) return 1;
      return a.label.localeCompare(b.label);
    };
    const prioritySeatRules = [
      { min: 1, max: 100, seats: new Set(['1', '2']) },
      { min: 101, max: 200, seats: new Set(['2', '3', '4']) },
      { min: 201, max: 300, seats: new Set(['4', '5']) },
      { min: 301, max: 400, seats: new Set(['6', '7']) },
    ];
    const getPrioritySeatRule = (priority) => {
      if (!Number.isFinite(priority)) return null;
      return (
        prioritySeatRules.find((rule) => priority >= rule.min && priority <= rule.max) ||
        null
      );
    };
    const getCardSeatNumbers = (cardMeta) => {
      if (!cardMeta) return [];
      const candidates = []
        .concat(cardMeta.sizeFilterKeys || [])
        .concat(cardMeta.sizeValues || [])
        .concat(cardMeta.normalizedSizes || []);
      return uniq(
        candidates
          .map((value) => extractSeatNumber(value))
          .filter(Boolean)
      );
    };
    const matchesPrioritySeatRule = (cardMeta) => {
      const rule = getPrioritySeatRule(cardMeta?.priority);
      if (!rule) return true;
      const seatNumbers = getCardSeatNumbers(cardMeta);
      if (!seatNumbers.length) return false;
      return seatNumbers.some((seat) => rule.seats.has(seat));
    };
    const escapeRegExp = (value) => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const containsTermBoundary = (text, token) => {
      if (!text || !token) return false;
      const pattern = new RegExp(`(?:^|\\b)${escapeRegExp(token)}(?:\\b|$)`);
      return pattern.test(text);
    };
    const getSofaTypeFromSize = (value) => {
      const norm = normalize(value);
      if (!norm) return null;
      if (norm.includes('footstool')) return 'footstool';
      if (norm.includes('chair')) return 'chair';
      if (norm.includes('recliner')) return 'recliners';
      if (
        norm.includes('sofa') ||
        norm.includes('seater') ||
        norm.includes('corner') ||
        norm.includes('shape') ||
        norm.includes('lounger')
      ) {
        return 'sofa';
      }
      return null;
    };
    const getSeatFromSize = (value) => {
      const norm = normalize(value);
      if (!norm) return null;
      if (norm.includes('corner')) return 'corner';
      if (norm.includes('l shape') || norm.includes('l-shape')) return 'l shape';
      if (norm.includes('u shape') || norm.includes('u-shape')) return 'u shape';
      const match = norm.match(/(\d+(?:\.\d+)?)\s*-?\s*seat/);
      if (match) return `${match[1]} seater`;
      return null;
    };
    const parseDimension = (value) => {
      const raw = (value ?? '').toString().replace(',', '.');
      const match = raw.match(/-?\d+(\.\d+)?/);
      if (!match) return NaN;
      return Number.parseFloat(match[0]);
    };
    const parseInteger = (value) => {
      const raw = (value ?? '').toString().trim();
      if (!raw) return null;
      const parsed = Number.parseInt(raw, 10);
      return Number.isFinite(parsed) ? parsed : null;
    };
    const toComparableDimension = (value) => {
      if (!Number.isFinite(value)) return null;
      const rounded = Math.round(value);
      if (rounded <= 0) return null;
      return rounded;
    };
    const clamp = (value, min, max) => Math.min(max, Math.max(min, value));
    const getAxisStep = (maxValue) => {
      if (!Number.isFinite(maxValue) || maxValue <= 0) return 50;
      if (maxValue <= 100) return 20;
      if (maxValue <= 300) return 50;
      return 100;
    };
    const matchesDimension = (selectedValue, cardValue) => {
      if (selectedValue === null) return true;
      const normalizedCard = toComparableDimension(cardValue);
      if (normalizedCard === null) return false;
      return normalizedCard <= selectedValue;
    };
    const matchesDimensionExact = (selectedValue, cardValue) => {
      if (selectedValue === null) return true;
      const normalizedCard = toComparableDimension(cardValue);
      if (normalizedCard === null) return false;
      return normalizedCard === selectedValue;
    };
    const normalizeActiveDimension = () => {
      const hasWidth = state.width !== null;
      if (!hasWidth) {
        state.activeDimension = null;
        return;
      }
      state.activeDimension = 'width';
    };
    const getActiveDimensionFilters = () => {
      return {
        width: state.width,
        height: null,
        depth: null,
      };
    };
    let minPrice = 0;
    let maxPrice = 0;
    const splitMeta = (value) => {
      const parseJsonList = (raw) => {
        try {
          const parsed = JSON.parse(raw);
          if (!Array.isArray(parsed)) return null;
          return parsed.map((item) => cleanMetaToken(item)).filter(Boolean);
        } catch (e) {
          return null;
        }
      };

      if (Array.isArray(value)) {
        return value.map((item) => cleanMetaToken(item)).filter(Boolean);
      }

      const raw = (value || '').toString().trim();
      if (!raw) return [];

      const decoded = raw.replace(/&quot;|&#34;/g, '"').replace(/&#39;/g, "'");
      const unwrapped = decoded.replace(/^["'](.*)["']$/, '$1');
      const parsedRaw = parseJsonList(raw);
      if (parsedRaw) return parsedRaw;
      const parsedDecoded = parseJsonList(decoded);
      if (parsedDecoded) return parsedDecoded;
      const parsedUnwrapped = parseJsonList(unwrapped);
      if (parsedUnwrapped) return parsedUnwrapped;

      return unwrapped
        .split(/[|,/;\n\r]+/)
        .map((item) => cleanMetaToken(item))
        .filter(Boolean);
    };
    const parseDimensionFromText = (rawText) => {
      const text = (rawText || '').toString();
      if (!text) return { width: null, height: null, depth: null };

      const pick = (patterns) => {
        for (const pattern of patterns) {
          const match = text.match(pattern);
          if (match && match[1]) {
            const parsed = toComparableDimension(parseDimension(match[1]));
            if (parsed !== null) return parsed;
          }
        }
        return null;
      };

      const width = pick([
        /overall\s*length[^0-9]*([0-9]+(?:\.[0-9]+)?)/i,
        /overall\s*width[^0-9]*([0-9]+(?:\.[0-9]+)?)/i,
        /\bwidth[^0-9]*([0-9]+(?:\.[0-9]+)?)/i,
      ]);
      const height = pick([
        /overall\s*height[^0-9]*([0-9]+(?:\.[0-9]+)?)/i,
        /\bheight[^0-9]*([0-9]+(?:\.[0-9]+)?)/i,
      ]);
      const depth = pick([
        /overall\s*depth[^0-9]*([0-9]+(?:\.[0-9]+)?)/i,
        /\bdepth[^0-9]*([0-9]+(?:\.[0-9]+)?)/i,
        /seat\s*depth[^0-9]*([0-9]+(?:\.[0-9]+)?)/i,
      ]);

      return { width, height, depth };
    };
    const cardMetaCache = new WeakMap();
    const buildCardMeta = (card) => {
      const widthValue = toComparableDimension(parseDimension(card?.dataset?.width));
      const heightValue = toComparableDimension(parseDimension(card?.dataset?.height));
      const depthValue = toComparableDimension(parseDimension(card?.dataset?.depth));
      const price = parseFloat(card?.dataset?.price);
      const titleValue = cleanMetaToken(card?.dataset?.title);
      const sizeValues = splitMeta(card?.dataset?.size);
      const sizeKeyValues = splitMeta(card?.dataset?.sizeKey).map(canonicalSize).filter(Boolean);
      const priority = parseInteger(card?.dataset?.priority);
      const dimensionsRaw = cleanMetaToken(card?.dataset?.dimensions);
      const parsedDimensions = parseDimensionFromText(dimensionsRaw);
      const colourValues = splitMeta(card?.dataset?.colour);
      const materialValues = splitMeta(card?.dataset?.material);
      const canonicalSizes = sizeValues.map(canonicalSize).filter(Boolean);
      return {
        width: widthValue ?? parsedDimensions.width,
        height: heightValue ?? parsedDimensions.height,
        depth: depthValue ?? parsedDimensions.depth,
        price,
        priority,
        titleValue,
        titleHasExcludedSizeCombo: isExcludedSizeFilterValue(titleValue),
        dimensionsRaw,
        sizeValues,
        sizeKeyValues,
        canonicalSizes,
        sizeFilterKeys: sizeKeyValues.length ? sizeKeyValues : canonicalSizes,
        normalizedSizes: sizeValues.map(normalizeSize).filter(Boolean),
        sofaTypes: sizeValues.map(getSofaTypeFromSize).filter(Boolean),
        seats: sizeValues.map(getSeatFromSize).filter(Boolean),
        colourValues,
        colors: colourValues.map(normalize),
        materialValues,
        types: materialValues.map(normalize),
      };
    };
    const getCardMeta = (card) => {
      if (!card) return null;
      const cached = cardMetaCache.get(card);
      if (cached) return cached;
      const cardMeta = buildCardMeta(card);
      cardMetaCache.set(card, cardMeta);
      return cardMeta;
    };
    const buildOptionMap = (values, normalizer, type) => {
      const map = new Map();
      const seenColors = new Set();
      
      values.forEach((raw) => {
        const norm = normalizer(raw);
        if (!norm) return;
        
        if (type === 'color') {
          const color = getSwatchColor(raw);
          // If we've already seen this exact visual color, skip it to prevent duplicates
          if (seenColors.has(color)) return;
          seenColors.add(color);
        }
        
        if (!map.has(norm)) map.set(norm, raw);
      });
      return Array.from(map.entries()).map(([value, label]) => ({ value, label }));
    };
    const renderOptions = (wrap, values, type) => {
      if (!wrap) return;
      wrap.innerHTML = '';
      values.forEach((value) => {
        const btn = document.createElement('button');
        btn.type = 'button';
        const label = typeof value === 'object' ? value.label : value;
        const optionValue = typeof value === 'object' ? value.value : value;

        if (type === 'color') {
          const colorLabel = toLabel(optionValue || label);
          btn.className = 'sofasizer__color-option';
          btn.dataset.optionValue = optionValue;
          btn.setAttribute('aria-label', colorLabel);
          btn.title = colorLabel;
          const swatch = document.createElement('span');
          swatch.className = 'sofasizer__swatch';
          swatch.style.setProperty('--swatch-color', getSwatchColor(label));
          swatch.setAttribute('aria-hidden', 'true');
          const visibleLabel = document.createElement('span');
          visibleLabel.className = 'sofasizer__color-label';
          visibleLabel.textContent = colorLabel;
          btn.appendChild(swatch);
          btn.appendChild(visibleLabel);
        } else {
          btn.className = 'sofasizer__chip';
          btn.textContent = label;
          btn.dataset.optionValue = optionValue;
        }
        btn.dataset.optionType = type;
        wrap.appendChild(btn);
      });
    };
    const renderTypeGroups = (wrap, groups) => {
      if (!wrap) return;
      wrap.innerHTML = '';

      const intro = document.createElement('p');
      intro.className = 'sofasizer__type-intro';
      intro.textContent = 'Select from the following...';
      wrap.appendChild(intro);

      const renderGroup = (groupLabel, optionType, options) => {
        if (!options.length) return;
        const group = document.createElement('div');
        group.className = 'sofasizer__type-group';
        group.classList.add(`sofasizer__type-group--${optionType}`);

        const label = document.createElement('div');
        label.className = 'sofasizer__type-label';
        label.textContent = `${groupLabel}:`;

        const grid = document.createElement('div');
        grid.className = 'sofasizer__type-grid';

        options.forEach((option) => {
          const item = document.createElement('label');
          item.className = 'sofasizer__type-option';

          const input = document.createElement('input');
          input.type = 'checkbox';
          input.dataset.optionType = optionType;
          input.dataset.optionValue = option.value;

          if (optionType === 'type-material' && state.typeMaterials.has(option.value)) input.checked = true;
          if (optionType === 'type-sofa-type' && state.typeSofaTypes.has(option.value)) input.checked = true;
          if (optionType === 'type-seat' && state.typeSeats.has(option.value)) input.checked = true;

          const text = document.createElement('span');
          text.textContent = option.label;

          item.appendChild(input);
          item.appendChild(text);
          grid.appendChild(item);
        });

        group.appendChild(label);
        group.appendChild(grid);
        wrap.appendChild(group);
      };

      renderGroup('Material', 'type-material', groups.materials);
      renderGroup('Sofa Type', 'type-sofa-type', groups.sofaTypes);
      renderGroup('Seats', 'type-seat', groups.seats);
    };
    const rebuildOptions = () => {
      sanitizeSelectedSizes();
      const sizeValues = [];
      const sizeOptionMap = new Map();
      const optionEligibleCards = cards.filter((card) => {
        const cardMeta = getCardMeta(card);
        if (!cardMeta || cardMeta.titleHasExcludedSizeCombo) return false;
        return matchesPrioritySeatRule(cardMeta);
      });

      optionEligibleCards.forEach((card) => {
        const cardMeta = getCardMeta(card);
        if (!cardMeta) return;
        const optionSource =
          cardMeta.sizeKeyValues && cardMeta.sizeKeyValues.length ? cardMeta.sizeKeyValues : cardMeta.sizeValues || [];
        const cardPriority = getPriorityRank(cardMeta);

        optionSource.forEach((rawValue) => {
          const canonicalValue = canonicalSize(rawValue);
          if (!canonicalValue || isExcludedSizeFilterValue(canonicalValue)) return;
          sizeValues.push(rawValue);

          const existing = sizeOptionMap.get(canonicalValue);
          if (!existing) {
            sizeOptionMap.set(canonicalValue, {
              value: canonicalValue,
              label: toSizeLabel(rawValue),
              priority: cardPriority,
            });
            return;
          }

          if (Number.isFinite(cardPriority) && cardPriority < existing.priority) {
            existing.priority = cardPriority;
          }
        });
      });

      const sizes = Array.from(sizeOptionMap.values()).sort(sizeOptionSort);
      sizeLabelMap = new Map(sizes.map((item) => [item.value, item.label]));
      const colors = buildOptionMap(
        optionEligibleCards.flatMap((card) => getCardMeta(card)?.colourValues || []),
        normalize,
        'color'
      );
      colorLabelMap = new Map(colors.map((item) => [item.value, toLabel(item.value)]));
      const materials = buildOptionMap(
        optionEligibleCards.flatMap((card) => getCardMeta(card)?.materialValues || []),
        normalize,
        'material'
      );

      const sofaTypeMap = new Map();
      const seatMap = new Map();
      sizeValues.forEach((value) => {
        const sofaType = getSofaTypeFromSize(value);
        if (sofaType && !sofaTypeMap.has(sofaType)) sofaTypeMap.set(sofaType, toLabel(sofaType));
        const seat = getSeatFromSize(value);
        if (seat && !seatMap.has(seat)) seatMap.set(seat, toSeatLabel(seat));
      });

      const sofaTypeOrder = ['chair', 'footstool', 'recliners', 'sofa'];
      const sofaTypes = Array.from(sofaTypeMap.entries())
        .map(([value, label]) => ({ value, label }))
        .sort((a, b) => {
          const ai = sofaTypeOrder.indexOf(a.value);
          const bi = sofaTypeOrder.indexOf(b.value);
          const safeAi = ai === -1 ? Number.MAX_SAFE_INTEGER : ai;
          const safeBi = bi === -1 ? Number.MAX_SAFE_INTEGER : bi;
          if (safeAi !== safeBi) return safeAi - safeBi;
          return a.label.localeCompare(b.label);
        });
      const seats = Array.from(seatMap.entries())
        .map(([value, label]) => ({ value, label }))
        .sort(seatSort);

      renderOptions(sizeWrap, sizes, 'size');
      renderOptions(colorWrap, colors, 'color');
      renderTypeGroups(typeWrap, { materials, sofaTypes, seats });

      root.querySelectorAll('[data-option-type="size"]').forEach((btn) => {
        const value = canonicalSize(btn.dataset.optionValue);
        if (state.sizes.has(value)) btn.classList.add('is-active');
      });
      root.querySelectorAll('[data-option-type="color"]').forEach((btn) => {
        const value = normalize(btn.dataset.optionValue);
        if (state.colors.has(value)) btn.classList.add('is-active');
      });
    };
    const syncPriceInputs = () => {
      if (priceMinRange) priceMinRange.value = state.priceMin ?? minPrice;
      if (priceMaxRange) priceMaxRange.value = state.priceMax ?? maxPrice;
    };
    const formatMoney = (value) => `${currencySymbol}${Math.round(value)}`;
    const updatePriceUI = () => {
      const minVal = state.priceMin ?? minPrice;
      const maxVal = state.priceMax ?? maxPrice;
      if (priceDisplayMin) priceDisplayMin.textContent = formatMoney(minVal);
      if (priceDisplayMax) priceDisplayMax.textContent = formatMoney(maxVal);
      if (priceLimitMin) priceLimitMin.textContent = formatMoney(minPrice);
      if (priceLimitMax) priceLimitMax.textContent = formatMoney(maxPrice);
    };
    const recalcPriceRange = () => {
      const prices = cards
        .map((card) => getCardMeta(card)?.price)
        .filter((value) => Number.isFinite(value));
      minPrice = prices.length ? Math.floor(Math.min(...prices)) : 0;
      maxPrice = prices.length ? Math.ceil(Math.max(...prices)) : 0;
      if (state.priceMin === null) state.priceMin = minPrice;
      if (state.priceMax === null) state.priceMax = maxPrice;
      if (priceMinRange) {
        priceMinRange.min = minPrice;
        priceMinRange.max = maxPrice;
      }
      if (priceMaxRange) {
        priceMaxRange.min = minPrice;
        priceMaxRange.max = maxPrice;
      }
      syncPriceInputs();
      updatePriceUI();
    };
    let lastSortSignature = '';
    const toSortValue = (value) => (Number.isFinite(value) ? value : -1);
    const hasActiveDimensionTarget = () => state.width !== null;
    const getDimensionKey = () => `${state.width ?? 'na'}`;
    const getCardSortDimension = (card, key) => {
      const cardMeta = getCardMeta(card);
      if (!cardMeta) return null;
      return cardMeta[key] ?? null;
    };
    const getCardDimensionScore = (card) => {
      const width = getCardSortDimension(card, 'width');
      if (width !== null) return width;
      return null;
    };
    const getDimensionMatchStats = (cardMeta) => {
      let exactCount = 0;
      let diffScore = 0;
      let checkedCount = 0;
      const register = (target, actual) => {
        if (target === null) return;
        checkedCount += 1;
        if (!Number.isFinite(actual)) {
          diffScore += 100000;
          return;
        }
        const diff = Math.abs(actual - target);
        diffScore += diff;
        if (diff === 0) exactCount += 1;
      };
      register(state.width, cardMeta?.width);
      return { exactCount, diffScore, checkedCount };
    };
    const getPriorityRank = (cardMeta) => {
      if (!cardMeta) return Number.MAX_SAFE_INTEGER;
      if (Number.isFinite(cardMeta.priority)) return cardMeta.priority;
      return Number.MAX_SAFE_INTEGER;
    };
    const sortCardsByDimension = (force = false) => {
      if (!resultsWrap || !cards.length) return;
      const hasDimensions = hasActiveDimensionTarget();
      const dimensionKey = getDimensionKey();
      const selectedSizeSignature = Array.from(state.sizes)
        .filter((value) => Boolean(value) && !isExcludedSizeFilterValue(value))
        .sort()
        .join(',');
      const hasSelectedSizes = selectedSizeSignature.length > 0;
      const sortSignature = `${hasDimensions ? 'dimension' : 'default'}|${dimensionKey}|${selectedSizeSignature}|${cards.length}`;
      if (!force && sortSignature === lastSortSignature) return;

      cards.sort((a, b) => {
        const aMeta = getCardMeta(a);
        const bMeta = getCardMeta(b);
        const aPriority = getPriorityRank(aMeta);
        const bPriority = getPriorityRank(bMeta);

        if (hasSelectedSizes && aPriority !== bPriority) return aPriority - bPriority;

        if (hasDimensions) {
          const aStats = getDimensionMatchStats(aMeta);
          const bStats = getDimensionMatchStats(bMeta);

          if (aStats.exactCount !== bStats.exactCount) return bStats.exactCount - aStats.exactCount;
          if (aStats.diffScore !== bStats.diffScore) return aStats.diffScore - bStats.diffScore;
        }

        if (aPriority !== bPriority) return aPriority - bPriority;

        const aPrimary = getCardDimensionScore(a);
        const bPrimary = getCardDimensionScore(b);
        const primaryDiff = toSortValue(bPrimary) - toSortValue(aPrimary);
        if (primaryDiff !== 0) return primaryDiff;

        const aSecondary = getCardSortDimension(a, 'width');
        const bSecondary = getCardSortDimension(b, 'width');
        const secondaryDiff = toSortValue(bSecondary) - toSortValue(aSecondary);
        if (secondaryDiff !== 0) return secondaryDiff;

        const aHeight = getCardSortDimension(a, 'height');
        const bHeight = getCardSortDimension(b, 'height');
        const heightDiff = toSortValue(bHeight) - toSortValue(aHeight);
        if (heightDiff !== 0) return heightDiff;

        const aDepth = getCardSortDimension(a, 'depth');
        const bDepth = getCardSortDimension(b, 'depth');
        return toSortValue(bDepth) - toSortValue(aDepth);
      });

      cards.forEach((card) => {
        if (emptyState && emptyState.parentElement === resultsWrap) resultsWrap.insertBefore(card, emptyState);
        else resultsWrap.appendChild(card);
      });

      lastSortSignature = sortSignature;
    };
    const matchesSizeSelection = (cardMeta) => {
      if (!state.sizes.size) return true;
      const selectedSizes = Array.from(state.sizes).filter(
        (value) => Boolean(value) && !isExcludedSizeFilterValue(value)
      );
      if (!selectedSizes.length) return true;

      const canonicalSizes = cardMeta?.sizeFilterKeys || [];
      const normalizedSizes = cardMeta?.normalizedSizes || [];
      const candidateSizes = uniq(canonicalSizes.concat(normalizedSizes));

      return selectedSizes.some((selected) => {
        const selectedCanonical = canonicalSize(selected);
        const selectedNormalized = normalizeSize(selected);
        const selectedSeatNumber = extractSeatNumber(selectedCanonical || selectedNormalized);

        return candidateSizes.some((candidate) => {
          const candidateCanonical = canonicalSize(candidate);
          const candidateNormalized = normalizeSize(candidate);

          if (candidateCanonical === selectedCanonical || candidateNormalized === selectedNormalized) return true;

          const candidateSeatNumber = extractSeatNumber(candidateCanonical || candidateNormalized);
          if (selectedSeatNumber && candidateSeatNumber) {
            return selectedSeatNumber === candidateSeatNumber;
          }

          if (!selectedSeatNumber && !candidateSeatNumber) {
            return (
              containsTermBoundary(candidateCanonical || candidateNormalized, selectedCanonical || selectedNormalized) ||
              containsTermBoundary(selectedCanonical || selectedNormalized, candidateCanonical || candidateNormalized)
            );
          }

          return false;
        });
      });
    };
    const colorMap = {
       'light grey': '#beb8b1',
      'light gray': '#beb8b1',
      'dark grey': '#444444',
      'dark gray': '#444444',
      'charcoal': '#2e2e2e',
      'stone': '#cfc6b8',
      'cream': '#fff9ea',
      'ivory': '#fdf9f3',
      'beige': '#e4d3b3',
      'taupe': '#b9a58f',
      'brown': '#6d4c41',
      'tan': '#b08d57',
      'camel': '#c19a6b',
      'black': '#111111',
      'white': '#ffffff',
      'blue': '#3a6ea5',
      'navy': '#1a2a3a',
      'green': '#2d5a27',
      'teal': '#008080',
      'red': '#b73b33',
      'burgundy': '#6b1d1d',
      'pink': '#d98ea5',
      'purple': '#7d5ba6',
      'orange': '#e0892f',
      'yellow': '#f2d04b',
      'silver': '#c0c0c0',
      'grey': '#8e8e8e',
      'gray': '#8e8e8e',
      'mink': '#968a81',
      'oatmeal': '#ecdec9',
      'slate': '#505b63',
      'pebble': '#b4b1a8',
      'mist': '#cbd5e0',
      'ash': '#bebebe',
      'duck egg': '#90b1b1',
      'mustard': '#e1ad01',
      'blush': '#ecbcb4',
      'mauve': '#673147',
      'gold': '#d4af37',
      'rose gold': '#b76e79',
      'silver grey': '#bfc1c2',
      'silver gray': '#bfc1c2',
      'platinum': '#e5e4e2',
      'graphite': '#383428',
      'smoke': '#738276',
      'pebbles': '#b4b1a8',
      'sand': '#e2ca76',
      'ebony': '#080808',
      'midnight': '#191970',
      'pearl': '#f7f7f7',
      'bone': '#e3dac9',
      'porcelain': '#fffff0',
      'off white': '#faf9f6',
      'dove grey': '#bbbcbf',
      'dove': '#bbbcbf',
      'lead': '#4f4f4f',
      'platinum': '#e5e4e2',
      'mist': '#d4dce3',
      'ash': '#b2b2b2',
      'truffle': '#8b8680',
      'dusky pink': '#b58392',
      'caramel': '#af6e4d',
      'roxy grey': '#4a5568',
      'charcoal grey': '#36454f',
      'multi': 'linear-gradient(45deg, #b73b33, #e0892f, #f2d04b, #3a6ea5, #7d5ba6)',
    };
    const resolveSwatchColorToken = (value) => {
      const raw = (value || '').toString().trim();
      if (!raw) return null;
      const hexMatch = raw.match(/#?([0-9a-f]{3}|[0-9a-f]{6})/i);
      if (hexMatch) return `#${hexMatch[1]}`;
      const norm = normalize(raw);
      if (colorMap[norm]) return colorMap[norm];
      return raw;
    };
    const getSwatchColor = (value) => {
      const raw = (value || '').toString().trim();
      const resolved = resolveSwatchColorToken(raw);
      if (resolved && typeof resolved === 'string' && resolved.startsWith('linear-gradient(')) return resolved;
      if (resolved && resolved !== raw) return resolved;

      const parts = raw
        .split(/\s*(?:\band\b|&|\/|\+|,)\s*/i)
        .map((item) => item.trim())
        .filter(Boolean);
      if (parts.length > 1) {
        const resolvedParts = parts
          .map((part) => resolveSwatchColorToken(part))
          .filter((part) => Boolean(part) && typeof part === 'string');
        if (resolvedParts.length > 1) {
          const steps = resolvedParts.map((part, index) => {
            const from = Math.round((index / resolvedParts.length) * 100);
            const to = Math.round(((index + 1) / resolvedParts.length) * 100);
            return `${part} ${from}% ${to}%`;
          });
          return `linear-gradient(135deg, ${steps.join(', ')})`;
        }
        if (resolvedParts.length === 1) return resolvedParts[0];
      }

      if (resolved) return resolved;
      return raw;
    };
    let sizeLabelMap = new Map();
    let colorLabelMap = new Map();
    const prefetchedHeroImages = new Set();
    let measureLineWidth = null;
    let measureLineHeight = null;
    let projectionLineVertical = null;
    let projectionLineHorizontal = null;

    const preloadHeroImages = (targetCards) => {
      if (!Array.isArray(targetCards) || !targetCards.length) return;
      targetCards.forEach((card) => {
        const src = card?.dataset?.image;
        if (!src || prefetchedHeroImages.has(src)) return;
        prefetchedHeroImages.add(src);
        const img = new Image();
        img.decoding = 'async';
        img.src = src;
      });
    };

    const buildAxisTicks = (axisElement, maxValue, axisType) => {
      if (!axisElement || !Number.isFinite(maxValue) || maxValue <= 0) return;
      axisElement.innerHTML = '';
      const step = getAxisStep(maxValue);
      const values = [0];
      for (let value = step; value < maxValue; value += step) values.push(value);
      if (values[values.length - 1] !== maxValue) values.push(maxValue);

      values.forEach((value, index) => {
        // Skip the second-to-last tick if it's too close to the end (within 30% of the step)
        if (index === values.length - 2 && values.length > 2) {
          const diff = values[index + 1] - value;
          if (diff < step * 0.45) return;
        }

        const tick = document.createElement('span');
        tick.className = `sofasizer__axis-tick sofasizer__axis-tick--${axisType}`;
        if (value === 0) tick.classList.add('is-start');
        if (value === maxValue) tick.classList.add('is-end');

        const ratio = maxValue ? value / maxValue : 0;
        const pos = axisType === 'y' ? (1 - ratio) * 100 : ratio * 100;
        tick.style.setProperty('--axis-pos', `${clamp(pos, 0, 100)}%`);
        tick.textContent = axisType === 'x' && value === maxValue ? `${value} cm` : `${value}`;
        axisElement.appendChild(tick);
      });
    };

    const renderAxes = () => {
      buildAxisTicks(axisX, maxWidth, 'x');
      buildAxisTicks(axisY, maxHeight, 'y');
    };

    const mountFloatingControls = () => {
      if (!stage || !resizeWrap) return;
      if (resizeWrap.parentElement !== stage) stage.appendChild(resizeWrap);
    };

    const ensureMeasureOverlay = () => {
      if (!stageGrid || measureLineWidth || measureLineHeight) return;

      measureLineWidth = document.createElement('div');
      measureLineWidth.className = 'sofasizer__measure-line sofasizer__measure-line--width';
      measureLineWidth.hidden = true;

      measureLineHeight = document.createElement('div');
      measureLineHeight.className = 'sofasizer__measure-line sofasizer__measure-line--height';
      measureLineHeight.hidden = true;

      stageGrid.appendChild(measureLineWidth);
      stageGrid.appendChild(measureLineHeight);
    };
    const ensureProjectionOverlay = () => {
      if (!stage || projectionLineVertical || projectionLineHorizontal) return;

      projectionLineVertical = document.createElement('div');
      projectionLineVertical.className = 'sofasizer__projection-line sofasizer__projection-line--vertical';
      projectionLineVertical.style.display = 'none';

      projectionLineHorizontal = document.createElement('div');
      projectionLineHorizontal.className = 'sofasizer__projection-line sofasizer__projection-line--horizontal';
      projectionLineHorizontal.style.display = 'none';

      stage.appendChild(projectionLineVertical);
      stage.appendChild(projectionLineHorizontal);
    };
    const updateProjectionOverlay = (anchorX, anchorY) => {
      if (!stage || !projectionLineVertical || !projectionLineHorizontal) return;
      const grid = getGridMetrics();
      if (!grid) return;

      const x = anchorX;
      const y = anchorY;

      // Vertical line: from current Y down to the bottom axis
      const bottomAxisY = grid.top + grid.height;
      const vLength = Math.max(0, bottomAxisY - y);

      if (vLength > 1) {
        projectionLineVertical.style.display = 'block';
        projectionLineVertical.style.left = `${x}px`;
        projectionLineVertical.style.top = `${y}px`;
        projectionLineVertical.style.height = `${vLength}px`;
      } else {
        projectionLineVertical.style.display = 'none';
      }

      // Horizontal line: from left axis across to current X
      const leftAxisX = grid.left;
      const hLength = Math.max(0, x - leftAxisX);

      if (hLength > 1) {
        projectionLineHorizontal.style.display = 'block';
        projectionLineHorizontal.style.left = `${leftAxisX}px`;
        projectionLineHorizontal.style.top = `${y}px`;
        projectionLineHorizontal.style.width = `${hLength}px`;
      } else {
        projectionLineHorizontal.style.display = 'none';
      }
    };

    const getGridMetrics = () => {
      if (!stage || !stageGrid) return null;
      const stageRect = stage.getBoundingClientRect();
      const gridRect = stageGrid.getBoundingClientRect();
      if (!gridRect.width || !gridRect.height) return null;
      return {
        left: gridRect.left - stageRect.left,
        top: gridRect.top - stageRect.top,
        width: gridRect.width,
        height: gridRect.height,
      };
    };

    const updateMeasureOverlay = (widthCm, heightCm) => {
      if (!measureLineWidth || !measureLineHeight) return;
      const grid = getGridMetrics();
      if (!grid) return;

      const hasWidth = Number.isFinite(widthCm) && widthCm > 0;
      const hasHeight = Number.isFinite(heightCm) && heightCm > 0;

      const widthPercent = hasWidth ? clamp((widthCm / maxWidth) * 100, 0, 100) : null;
      const heightPercent = hasHeight ? clamp(100 - (heightCm / maxHeight) * 100, 0, 100) : null;

      if (hasWidth) {
        measureLineWidth.hidden = false;
        measureLineWidth.style.left = `${widthPercent}%`;
      } else {
        measureLineWidth.hidden = true;
      }

      if (hasHeight) {
        measureLineHeight.hidden = false;
        measureLineHeight.style.top = `${heightPercent}%`;
        measureLineHeight.style.width = hasWidth ? `${widthPercent}%` : '100%';
      } else {
        measureLineHeight.hidden = true;
      }

      if (resizeLabel) {
        if (hasWidth || hasHeight) {
          let labelText = '';
          if (hasWidth && hasHeight) labelText = `W${Math.round(widthCm)} x H${Math.round(heightCm)} cm`;
          else if (hasWidth) labelText = `W${Math.round(widthCm)} cm`;
          else labelText = `H${Math.round(heightCm)} cm`;
          resizeLabel.textContent = labelText;
          resizeLabel.classList.remove('is-hint');
          resizeLabel.hidden = false;
        } else {
          resizeLabel.textContent = 'Drag to size';
          resizeLabel.classList.add('is-hint');
          resizeLabel.hidden = false;
        }
      }
    };

    const updateChips = () => {
      if (!filtersWrap) return;
      filtersWrap.innerHTML = '';
      const chips = [];
      const hasWidth = state.width !== null;
      state.sizes.forEach((value) => {
        if (isExcludedSizeFilterValue(value)) return;
        const label = sizeLabelMap.get(value) || value;
        chips.push(`Size: ${label}`);
      });
      state.colors.forEach((value) => {
        const label = colorLabelMap.get(value) || toLabel(value);
        chips.push(`Colour: ${label}`);
      });
      state.typeMaterials.forEach((value) => chips.push(`Material: ${toLabel(value)}`));
      state.typeSofaTypes.forEach((value) => chips.push(`Sofa Type: ${toLabel(value)}`));
      state.typeSeats.forEach((value) => chips.push(`Seats: ${toSeatLabel(value)}`));
      if (hasWidth) chips.push(`Size: w${state.width} cm x`);
      if (state.priceMin !== null || state.priceMax !== null) {
        chips.push(`Price: ${formatMoney(state.priceMin)} - ${formatMoney(state.priceMax)}`);
      }

      chips.forEach((label) => {
        const chip = document.createElement('span');
        chip.className = 'sofasizer__chip';
        chip.textContent = label;
        filtersWrap.appendChild(chip);
      });

      if (clearBtn) {
        clearBtn.textContent = 'Clear All';
        clearBtn.type = 'button';
        clearBtn.dataset.clearFilters = '';
        filtersWrap.appendChild(clearBtn);
      }
    };
    const applyFilters = () => {
      sortCardsByDimension();
      const activeFilters = getActiveDimensionFilters();
      const hasColorFilter = state.colors.size > 0;
      const hasMaterialFilter = state.typeMaterials.size > 0;
      const hasSofaTypeFilter = state.typeSofaTypes.size > 0;
      const hasSeatFilter = state.typeSeats.size > 0;
      let visible = 0;
      let matched = 0;
      const matchingCards = [];
      let firstVisibleCard = null;
      let widestCard = null;
      let widestWidth = -1;
      cards.forEach((card) => {
        const cardMeta = getCardMeta(card);

        let show = true;

        if (!matchesSizeSelection(cardMeta)) show = false;
        if (show && !matchesPrioritySeatRule(cardMeta)) show = false;

        if (show && !matchesDimension(activeFilters.width, cardMeta.width)) show = false;
        if (show && !matchesDimension(activeFilters.height, cardMeta.height)) show = false;
        if (show && !matchesDimension(activeFilters.depth, cardMeta.depth)) show = false;

        if (show && hasColorFilter) {
          const hasColor = cardMeta.colors.some((color) => state.colors.has(color));
          if (!hasColor) show = false;
        }

        if (show && hasMaterialFilter) {
          const hasMaterial = cardMeta.types.some((type) => state.typeMaterials.has(type));
          if (!hasMaterial) show = false;
        }

        if (show && hasSofaTypeFilter) {
          const hasSofaType = cardMeta.sofaTypes.some((type) => state.typeSofaTypes.has(type));
          if (!hasSofaType) show = false;
        }

        if (show && hasSeatFilter) {
          const hasSeat = cardMeta.seats.some((seat) => state.typeSeats.has(seat));
          if (!hasSeat) show = false;
        }

        if (show && Number.isFinite(cardMeta.price)) {
          if (cardMeta.price < state.priceMin || cardMeta.price > state.priceMax) show = false;
        }

        let shouldHide = true;
        if (show) {
          matched += 1;
          if (Number.isFinite(cardMeta.width) && cardMeta.width > widestWidth) {
            widestWidth = cardMeta.width;
            widestCard = card;
          }
          if (visible < currentLimit) {
            visible += 1;
            if (!firstVisibleCard) firstVisibleCard = card;
            matchingCards.push(card);
            shouldHide = false;
          } else {
            matchingCards.push(card);
          }
        }
        if (card.hidden !== shouldHide) card.hidden = shouldHide;
      });

      if (resultsMeta) {
        resultsMeta.textContent = `${visible} of ${matched} results`;
      }
      if (emptyState) {
        emptyState.hidden = matched !== 0;
      }
      hasMoreResults = matched > visible;
      if (loadMoreBtn) {
        loadMoreBtn.hidden = !hasMoreResults;
      }
      updateChips();
      updateTopWidthProduct(widestCard, widestWidth);
      preloadHeroImages(matchingCards.slice(0, 12));

      // Carousel logic: sequence through the top matching products to show variety
      let heroCard = firstVisibleCard;
      const hasSelectedSizes = Array.from(state.sizes).some(
        (value) => Boolean(value) && !isExcludedSizeFilterValue(value)
      );
      if (hasSelectedSizes && matchingCards.length) {
        heroCard = matchingCards[0];
      } else if (matchingCards.length > 1) {
        // Take up to the top 15 best matching products from the search results
        const topMatches = matchingCards.slice(0, 15);
        // Change image every 2cm of dragging
        const cycleIndex = Math.floor((state.width || 0) / 2) % topMatches.length;
        heroCard = topMatches[cycleIndex];
      }

      updateHero(heroCard || firstVisibleCard);

      syncSofaPreview(state.width, state.height);
    };

    const loadNextBatch = () => {
      if (!hasMoreResults || isAutoLoadingMore) return;
      isAutoLoadingMore = true;
      currentLimit += pageSize;
      applyFilters();
      window.requestAnimationFrame(() => {
        isAutoLoadingMore = false;
      });
    };

    const onAutoLoadScroll = () => {
      if (!loadMoreBtn || loadMoreBtn.hidden) return;
      if (autoLoadScrollRaf !== null) return;
      autoLoadScrollRaf = window.requestAnimationFrame(() => {
        autoLoadScrollRaf = null;
        if (!loadMoreBtn || loadMoreBtn.hidden) return;
        const rect = loadMoreBtn.getBoundingClientRect();
        if (rect.top <= window.innerHeight + 260) {
          loadNextBatch();
        }
      });
    };

    const initAutoLoadMore = () => {
      if (!loadMoreBtn) return;
      if ('IntersectionObserver' in window) {
        autoLoadObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) loadNextBatch();
            });
          },
          { root: null, rootMargin: '260px 0px 260px 0px', threshold: 0.01 }
        );
        autoLoadObserver.observe(loadMoreBtn);
        return;
      }
      window.addEventListener('scroll', onAutoLoadScroll, { passive: true });
    };

    let dragFilterTimer = null;
    let previewFrame = null;
    const scheduleFilterApply = () => {
      // Throttle while dragging so tiny movements still refresh results/image live.
      if (dragFilterTimer) return;
      dragFilterTimer = window.setTimeout(() => {
        dragFilterTimer = null;
        currentLimit = pageSize;
        applyFilters();
      }, 16);
    };
    const schedulePreviewSync = () => {
      if (previewFrame !== null) return;
      previewFrame = window.requestAnimationFrame(() => {
        previewFrame = null;
        syncSofaPreview(state.width, state.height);
      });
    };

    const syncSofaPreview = (widthCm, heightCm) => {
      if (!sofaWrap) return;

      const hasWidth = Number.isFinite(widthCm) && widthCm > 0;
      const hasHeight = Number.isFinite(heightCm) && heightCm > 0;
      const baseWidthRatio = 0.7;
      const widthRatio = hasWidth ? clamp(widthCm / maxWidth, 0.15, 1) : baseWidthRatio;
      const heightRatio = hasHeight ? clamp(heightCm / maxHeight, 0.15, 1) : 1;

      sofaWrap.style.width = `${(widthRatio * 100).toFixed(2)}%`;
      sofaWrap.style.setProperty('--sofa-image-height', `${(heightRatio * 100).toFixed(2)}%`);

      if (resizeWrap) {
        const controlScale = clamp(widthRatio / baseWidthRatio, 0.82, 1.15);
        resizeWrap.style.setProperty('--resize-control-scale', controlScale.toFixed(3));
      }
      updateMeasureOverlay(hasWidth ? widthCm : null, hasHeight ? heightCm : null);
      syncResizeControlPosition();
    };

    const getPreviewBoxHeight = (wrapHeight) => {
      if (!Number.isFinite(wrapHeight) || wrapHeight <= 0) return 0;
      return wrapHeight;
    };

    const getRenderedImageBounds = () => {
      if (!sofaWrap) return null;
      const wrapWidth = sofaWrap.clientWidth;
      const wrapHeight = sofaWrap.clientHeight;
      if (wrapWidth <= 0 || wrapHeight <= 0) return null;

      if (!heroImage || heroImage.hidden) {
        return {
          left: 0,
          top: 0,
          width: wrapWidth,
          height: wrapHeight,
        };
      }
      const naturalWidth = heroImage.naturalWidth;
      const naturalHeight = heroImage.naturalHeight;
      if (!naturalWidth || !naturalHeight) {
        return {
          left: 0,
          top: 0,
          width: wrapWidth,
          height: wrapHeight,
        };
      }
      const boxHeight = getPreviewBoxHeight(wrapHeight);
      const scale = Math.min(wrapWidth / naturalWidth, boxHeight / naturalHeight);
      const width = naturalWidth * scale;
      const height = naturalHeight * scale;
      const left = 0;
      const top = wrapHeight - height;

      return {
        left,
        top,
        width: Number.isFinite(width) ? width : wrapWidth,
        height: Number.isFinite(height) ? height : wrapHeight,
      };
    };
    const getImageAnchorInStage = () => {
      if (!stage || !sofaWrap) return null;
      const imageBounds = getRenderedImageBounds();
      if (!imageBounds) return null;

      const sofaRect = sofaWrap.getBoundingClientRect();
      const stageRect = stage.getBoundingClientRect();
      const left = sofaRect.left - stageRect.left + imageBounds.left;
      const top = sofaRect.top - stageRect.top + imageBounds.top;
      const right = left + imageBounds.width;

      return { left, top, right };
    };
    const syncResizeControlPosition = () => {
      if (!resizeWrap || !stage) return;
      const grid = getGridMetrics();
      if (!grid) {
        if (projectionLineVertical) projectionLineVertical.hidden = true;
        if (projectionLineHorizontal) projectionLineHorizontal.hidden = true;
        return;
      }

      const hasWidth = Number.isFinite(state.width) && state.width > 0;
      const hasHeight = Number.isFinite(state.height) && state.height > 0;
      const imageAnchor = getImageAnchorInStage();

      let anchorX = grid.left + grid.width;
      let anchorY = grid.top;

      if (hasWidth) {
        anchorX = grid.left + clamp((state.width / maxWidth) * grid.width, 0, grid.width);
      } else if (imageAnchor) {
        anchorX = imageAnchor.right;
      }
      if (hasHeight) {
        anchorY = grid.top + clamp((1 - state.height / maxHeight) * grid.height, 0, grid.height);
      } else if (imageAnchor) {
        anchorY = imageAnchor.top;
      }

      anchorX = clamp(anchorX, grid.left, grid.left + grid.width);
      anchorY = clamp(anchorY, grid.top, grid.top + grid.height);

      resizeWrap.style.left = `${anchorX}px`;
      resizeWrap.style.top = `${anchorY}px`;
      resizeWrap.style.right = 'auto';
      updateProjectionOverlay(anchorX, anchorY);
    };

    const updateHero = (card) => {
      if (!heroImage) return;
      const src = card?.dataset.image;
      const alt = card?.dataset.imageAlt || '';
      const defaultSrc = heroImage.dataset.defaultSrc;
      const currentSrc = heroImage.currentSrc || heroImage.src || '';

      if (src) {
        if (currentSrc !== src) heroImage.src = src;
        if (heroImage.alt !== alt) heroImage.alt = alt;
        heroImage.hidden = false;
        if (heroPlaceholder) heroPlaceholder.hidden = true;
        syncResizeControlPosition();
        return;
      }

      if (defaultSrc) {
        if (currentSrc !== defaultSrc) heroImage.src = defaultSrc;
        heroImage.hidden = false;
        if (heroPlaceholder) heroPlaceholder.hidden = true;
        syncResizeControlPosition();
      } else {
        heroImage.hidden = true;
        if (heroPlaceholder) heroPlaceholder.hidden = false;
        syncResizeControlPosition();
      }
    };

    const setNumber = (value) => {
      const next = parseDimension(value);
      return toComparableDimension(next);
    };
    const getCardTitle = (card) => {
      const dataTitle = (card?.dataset?.title || '').toString().trim();
      if (dataTitle) return dataTitle;
      const titleNode = card?.querySelector('.sofasizer__card-title');
      return titleNode ? titleNode.textContent.trim() : '';
    };
    const updateTopWidthProduct = (card, width) => {
      if (!topWidthProduct) return;
      if (!card || !Number.isFinite(width) || width <= 0) {
        topWidthProduct.hidden = true;
        topWidthProduct.textContent = '';
        return;
      }
      const title = getCardTitle(card);
      if (!title) {
        topWidthProduct.hidden = true;
        topWidthProduct.textContent = '';
        return;
      }
      topWidthProduct.textContent = `Widest: ${title} (${Math.round(width)} cm)`;
      topWidthProduct.hidden = false;
    };

    const handleSizeInput = (event) => {
      const source = event?.target?.dataset?.sizeInput || null;
      const nextHeight = setNumber(heightInput?.value);
      const nextWidth = setNumber(widthInput?.value);
      const nextDepth = setNumber(depthInput?.value);
      state.height = nextHeight === null ? null : Math.min(nextHeight, maxHeight);
      state.width = nextWidth === null ? null : Math.min(nextWidth, maxWidth);
      state.depth = nextDepth === null ? null : Math.min(nextDepth, maxDepth);
      if (source === 'width') state.activeDimension = 'width';
      if (source === 'height') state.activeDimension = 'height';
      normalizeActiveDimension();

      if (event?.type === 'change') {
        if (heightInput) heightInput.value = state.height ?? '';
        if (widthInput) widthInput.value = state.width ?? '';
        if (depthInput) depthInput.value = state.depth ?? '';
      }

      currentLimit = pageSize;
      if (event?.type === 'input') {
        schedulePreviewSync();
        scheduleFilterApply();
      } else {
        syncSofaPreview(state.width, state.height);
        if (dragFilterTimer) {
          window.clearTimeout(dragFilterTimer);
          dragFilterTimer = null;
        }
        if (previewFrame !== null) {
          window.cancelAnimationFrame(previewFrame);
          previewFrame = null;
        }
        applyFilters();
      }
    };

    const handlePriceChange = (minValue, maxValue) => {
      const min = Math.max(minPrice, Math.min(minValue, maxValue));
      const max = Math.min(maxPrice, Math.max(minValue, maxValue));
      state.priceMin = Math.round(min);
      state.priceMax = Math.round(max);
      syncPriceInputs();
      updatePriceUI();
      applyFilters();
    };

    const buildCard = (product) => {
      const card = document.createElement('article');
      card.className = 'sofasizer__card';
      card.dataset.width = product.width || '';
      card.dataset.height = product.height || '';
      card.dataset.depth = product.depth || '';
      card.dataset.title = product.title || '';
      card.dataset.sizeKey = product.size_key || '';
      card.dataset.priority = product.sizer_priority || product.priority || '';
      card.dataset.dimensions = product.dimensions || '';
      card.dataset.price = product.price || '';
      card.dataset.size = product.size || '';
      card.dataset.colour = product.colour || '';
      card.dataset.material = product.material || '';
      card.dataset.image = product.image || '';
      card.dataset.imageAlt = product.image_alt || product.title || '';

      const imgHtml = product.image
        ? `<img src="${product.image}" alt="${product.image_alt || ''}" loading="lazy">`
        : '';

      card.innerHTML = `
        <a class="sofasizer__card-link" href="${product.url}">
          <div class="sofasizer__card-media">${imgHtml}</div>
          <div class="sofasizer__card-body">
            <h3 class="sofasizer__card-title">${product.title}</h3>
            <div class="sofasizer__card-dimensions">
              ${product.height ? `H${product.height}` : ''}${product.width ? (product.height ? ' x ' : '') + `W${product.width}` : ''}${product.depth ? (product.height || product.width ? ' x ' : '') + `D${product.depth}` : ''}${product.height || product.width || product.depth ? ' cm' : ''}
            </div>
            <div class="sofasizer__card-price">${product.price_formatted || ''}</div>
          </div>
        </a>
      `;
      return card;
    };

    const fetchAllPages = async () => {
      if (!resultsWrap || totalPages <= 1) return;
      for (let page = 2; page <= totalPages; page += 1) {
        const url = `/collections/${collectionHandle}?view=sofasizer-data&page=${page}`;
        try {
          const res = await fetch(url, { credentials: 'same-origin' });
          if (!res.ok) break;
          const data = await res.json();
          if (!Array.isArray(data.products)) continue;
          const newCards = data.products.map(buildCard);
          newCards.forEach((card) => {
            resultsWrap.insertBefore(card, emptyState);
          });
          cards = cards.concat(newCards);
        } catch (e) {
          break;
        }
      }
      sortCardsByDimension(true);
      recalcPriceRange();
      rebuildOptions();
      applyFilters();
    };

    ensureMeasureOverlay();
    ensureProjectionOverlay();
    mountFloatingControls();
    renderAxes();
    recalcPriceRange();
    rebuildOptions();

    root.addEventListener('click', (event) => {
      const target = event.target;
      if (!(target instanceof HTMLElement)) return;
      if (target.classList.contains('sofasizer__tab')) {
        tabButtons.forEach((btn) => btn.classList.remove('is-active'));
        target.classList.add('is-active');
        panels.forEach((panel) => {
          panel.classList.toggle('is-active', panel.dataset.panel === target.dataset.tab);
        });
      }

      const colorButton = target.closest('button[data-option-type="color"]');
      if (colorButton && root.contains(colorButton)) {
        const value = normalize(colorButton.dataset.optionValue);
        if (state.colors.has(value)) {
          state.colors.delete(value);
          colorButton.classList.remove('is-active');
        } else {
          state.colors.add(value);
          colorButton.classList.add('is-active');
        }
        currentLimit = pageSize;
        applyFilters();
      }

      const sizeButton = target.closest('button[data-option-type="size"]');
      if (sizeButton && root.contains(sizeButton)) {
        const value = canonicalSize(sizeButton.dataset.optionValue);
        if (!value || isExcludedSizeFilterValue(value)) return;
        if (state.sizes.has(value)) {
          state.sizes.delete(value);
          sizeButton.classList.remove('is-active');
        } else {
          state.sizes.add(value);
          sizeButton.classList.add('is-active');
        }
        currentLimit = pageSize;
        applyFilters();
      }

      if (target.closest('[data-clear-filters]')) {
        state.height = null;
        state.width = null;
        state.depth = null;
        state.activeDimension = null;
        state.sizes.clear();
        state.colors.clear();
        state.typeMaterials.clear();
        state.typeSofaTypes.clear();
        state.typeSeats.clear();
        state.priceMin = minPrice;
        state.priceMax = maxPrice;
        if (heightInput) heightInput.value = '';
        if (widthInput) widthInput.value = '';
        if (depthInput) depthInput.value = '';
        normalizeActiveDimension();
        syncSofaPreview(null, null);
        root.querySelectorAll('button[data-option-type]').forEach((btn) => btn.classList.remove('is-active'));
        root.querySelectorAll('input[type="checkbox"][data-option-type]').forEach((input) => {
          input.checked = false;
        });
        syncPriceInputs();
        currentLimit = pageSize;
        applyFilters();
      }
    });

    root.addEventListener('change', (event) => {
      const target = event.target;
      if (!(target instanceof HTMLInputElement)) return;
      if (target.type !== 'checkbox') return;

      const { optionType, optionValue } = target.dataset;
      if (!optionType || !optionValue) return;

      if (optionType === 'type-material') {
        if (target.checked) state.typeMaterials.add(optionValue);
        else state.typeMaterials.delete(optionValue);
      }

      if (optionType === 'type-sofa-type') {
        if (target.checked) state.typeSofaTypes.add(optionValue);
        else state.typeSofaTypes.delete(optionValue);
      }

      if (optionType === 'type-seat') {
        if (target.checked) state.typeSeats.add(optionValue);
        else state.typeSeats.delete(optionValue);
      }

      currentLimit = pageSize;
      applyFilters();
    });

    heightInput?.addEventListener('input', handleSizeInput);
    widthInput?.addEventListener('input', handleSizeInput);
    depthInput?.addEventListener('input', handleSizeInput);
    heightInput?.addEventListener('change', handleSizeInput);
    widthInput?.addEventListener('change', handleSizeInput);
    depthInput?.addEventListener('change', handleSizeInput);

    priceMinRange?.addEventListener('input', (event) => {
      currentLimit = pageSize;
      handlePriceChange(parseFloat(event.target.value || minPrice), state.priceMax);
    });
    priceMaxRange?.addEventListener('input', (event) => {
      currentLimit = pageSize;
      handlePriceChange(state.priceMin, parseFloat(event.target.value || maxPrice));
    });

    heroImage?.addEventListener('load', () => {
      syncSofaPreview(state.width, state.height);
    });

    window.addEventListener('resize', () => {
      syncSofaPreview(state.width, state.height);
    });

    if (resizeHandle && stage) {
      let resizeStart = null;
      let resizePointerTarget = null;
      let resizePointerId = null;

      const setResizingState = (isResizing) => {
        if (sofaWrap) sofaWrap.classList.toggle('is-resizing', isResizing);
        resizeHandle.classList.toggle('is-resizing', isResizing);
      };

      const getResizeBounds = () => {
        const gridBounds = stageGrid?.getBoundingClientRect();
        if (gridBounds && gridBounds.width > 20 && gridBounds.height > 20) return gridBounds;
        return stage.getBoundingClientRect();
      };

      const onPointerMove = (event) => {
        if (!resizeStart) return;
        event.preventDefault();

        const bounds = getResizeBounds();
        if (!bounds.width || !bounds.height) return;

        const x = Math.min(Math.max(event.clientX - bounds.left, 0), bounds.width);
        const y = Math.min(Math.max(event.clientY - bounds.top, 0), bounds.height);
        const nextWidth = Math.round((x / bounds.width) * maxWidth);
        const nextHeight = Math.round(((bounds.height - y) / bounds.height) * maxHeight);
        const deltaX = Math.abs(event.clientX - resizeStart.x);
        const deltaY = Math.abs(event.clientY - resizeStart.y);

        state.width = nextWidth > 0 ? nextWidth : null;
        state.height = nextHeight > 0 ? nextHeight : null;
        if (deltaY > deltaX + 4) state.activeDimension = 'height';
        else if (deltaX > deltaY + 4) state.activeDimension = 'width';
        normalizeActiveDimension();
        if (widthInput) widthInput.value = state.width ?? '';
        if (heightInput) heightInput.value = state.height ?? '';
        schedulePreviewSync();
        scheduleFilterApply();
      };

      const onPointerUp = () => {
        resizeStart = null;
        setResizingState(false);
        if (
          resizePointerTarget &&
          resizePointerId !== null &&
          typeof resizePointerTarget.releasePointerCapture === 'function'
        ) {
          try {
            resizePointerTarget.releasePointerCapture(resizePointerId);
          } catch (e) {
            // Ignore release failures.
          }
        }
        resizePointerTarget = null;
        resizePointerId = null;
        window.removeEventListener('pointermove', onPointerMove);
        window.removeEventListener('pointerup', onPointerUp);
        window.removeEventListener('pointercancel', onPointerUp);
        if (dragFilterTimer) {
          window.clearTimeout(dragFilterTimer);
          dragFilterTimer = null;
        }
        currentLimit = pageSize;
        applyFilters();
      };

      const startResize = (event, pointerTarget) => {
        if (typeof event.button === 'number' && event.button !== 0) return;
        event.preventDefault();
        resizeStart = { x: event.clientX, y: event.clientY };
        resizePointerTarget = pointerTarget;
        resizePointerId = typeof event.pointerId === 'number' ? event.pointerId : null;
        setResizingState(true);
        window.addEventListener('pointermove', onPointerMove);
        window.addEventListener('pointerup', onPointerUp);
        window.addEventListener('pointercancel', onPointerUp);
        if (typeof pointerTarget.setPointerCapture === 'function') {
          try {
            pointerTarget.setPointerCapture(event.pointerId);
          } catch (e) {
            // Ignore capture failures; window listeners already handle drag.
          }
        }
      };

      resizeHandle.addEventListener('pointerdown', (event) => {
        startResize(event, resizeHandle);
      });

      sofaWrap?.addEventListener('pointerdown', (event) => {
        startResize(event, sofaWrap);
      });
    }

    loadMoreBtn?.addEventListener('click', () => {
      currentLimit += pageSize;
      applyFilters();
    });

    initAutoLoadMore();
    applyFilters();
    fetchAllPages();
  });
})();
